import React, { useEffect } from 'react'
import { get } from 'lodash'

import { useRequest } from '../hooks/request'
import {
  gridSave, gridPublishPath, gridPublish, gridGet,
} from '../requests/grid'
import { DOCUMENT_STATUS } from '../constants/documentStatus'
import { PATHS } from '../constants/paths'

import { PageTitle } from './common/PageTitle'
import { PageContent } from './layout/layout'
import { CenterStuff } from './common/CenterStuff'
import { Loader } from './icons/Loader'
import { GridForm } from './GridForm'
import { Menu } from './common/Typography'
import { useMatches, useParams } from 'react-router-dom'

const createDocumentEdit = ({
  saveRequest,
  publishRequest,
  getRequest,
  viewTitle,
  editTitle,
  publishedUpdateRequest,
  publishedUpdatePath,
  publishPath,
  Form,
  backLink,
  backLinkTrad,
}) => () => {
  const params = useParams()
  const documentId = params.id
  
  const documentRequest = useRequest({
    request: () => getRequest({ params: { id: documentId } }),
    start: true,
  })
  const documentSaveRequest = useRequest({
    request: saveRequest,
    handler: (p) => p.then(documentRequest.fetch),
  })

  const documentPublishRequest = useRequest({
    request: publishRequest,
    handler: (p) => p.then(documentRequest.fetch),
  })

  const documentUpdateRequest = useRequest({
    request: publishedUpdateRequest,
    handler: (p) => p.then(documentRequest.fetch),
  })


  const publicationSuccess = documentPublishRequest.state.success
  const saveSuccess = documentSaveRequest.state.success

  useEffect(() => {
    if (saveSuccess) {
      documentRequest.setData({ data: documentSaveRequest.state.data })
    }

    if (publicationSuccess) {
      documentRequest.setData({ data: documentPublishRequest.state.data })
    }
  }, [publicationSuccess, saveSuccess])


  if (documentRequest.state.loading || !documentRequest.state.data) {
    return (
      <CenterStuff>
        <Loader height={100} />
      </CenterStuff>
    )
  }

  if (documentRequest.state.data === null) {
    return (
      <>
        <PageTitle tradId={viewTitle} backLink={backLink} backLinkTrad={backLinkTrad} />
        <PageContent>
          <Menu tradId="documentDoesntExist" />
        </PageContent>
      </>
    )
  }
  const initialValues = documentRequest.state.data
  const disabled = initialValues.status === DOCUMENT_STATUS.PUBLISHED
  const finalSubmit = disabled && publishedUpdateRequest ? documentUpdateRequest.fetch : documentPublishRequest.fetch
  const finalPath = disabled && publishedUpdatePath ? publishedUpdatePath : publishPath

  return (
    <>
      <PageTitle tradId={disabled ? viewTitle : editTitle} backLink={backLink} backLinkTrad={backLinkTrad} />
      <PageContent>
        <Form
          disabled={disabled}
          initialValues={initialValues}
          onSave={documentSaveRequest.fetch}
          onSubmit={finalSubmit}
          path={finalPath}
          saveSuccess={documentSaveRequest.state.success}
          saveLoading={documentSaveRequest.state.loading}
          publishLoading={documentPublishRequest.state.loading}
        />
      </PageContent>
    </>
  )
}

export const GridEdit = createDocumentEdit({
  saveRequest: gridSave,
  publishRequest: gridPublish,
  getRequest: gridGet,
  publishPath: gridPublishPath,
  viewTitle: 'gridView',
  editTitle: 'gridEdit',
  Form: GridForm,
  backLink: PATHS.GRID_LIST,
  backLinkTrad: 'gridList',
})
